import React from 'react'
import { projects } from "../../../mock/projects"
import { Section } from "../../ui"
import '../../../assets/images/project_1.png'
import '../../../assets/images/project_2.png'
import { Link } from 'react-router-dom'

import './projects.scss'

const ProjectsSection = ({ title, variant }) => {

    return (
        <Section variant={variant}>
            <div className="projects">
                <h2 className="projects-title">{title || "Our Projects"}</h2>
                <ul className="projects-list">
                    {
                        projects.map(({image, title, description}, i) => (
                            <li className="item-wrapper" key={i}>
                                <div className="item-content_container">
                                    <h5 className="item-title">{title}</h5>
                                    <p className="item-description">{description}</p>
                                    <Link to="/collection/alien_in_marigolds"><button className="explore_btn">Explore Now</button></Link>
                                </div>
                                <img src={require(image)}/>
                            </li>
                        ))
                    }
                </ul>
            </div>
        </Section>
    )
}

export default ProjectsSection